import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ButtonModule } from "../button/button.module";
import { IconModule } from "../icon/icon.module";
import { CollapsibleModalComponent } from "./collapsible-modal/collapsible-modal.component";
import { ConfirmationModalComponent } from "./confirmation-modal/confirmation-modal.component";
import { ModalComponent } from "./modal/modal.component";
import { PopoverComponent } from "./popover/popover.component";

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    DialogModule,
    IconModule,
    OverlayPanelModule,
  ],
  declarations: [
    ModalComponent,
    PopoverComponent,
    ConfirmationModalComponent,
    CollapsibleModalComponent,
  ],
  exports: [
    ModalComponent,
    PopoverComponent,
    ConfirmationModalComponent,
    CollapsibleModalComponent,
  ],
})
export class PanelModule { }
